// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manageForm[data-v-62403da4] .el-dialog__body{height:calc(90vh - 110px);overflow:auto;padding:15px}.manageForm[data-v-62403da4] .el-dialog__footer{text-align:left;padding:0}", ""]);
// Exports
module.exports = exports;
